import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const REVEAL_CARD_SELECTOR = '.fz-product-card'
const REVEAL_DISTANCE_PX = 24
const REVEAL_DURATION_S = 0.8
const REVEAL_STAGGER_S = 0.06
const REVEAL_START = 'top 88%'

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

export function createEditorialRevealAnimation(
  container: HTMLElement | null,
  selector: string = REVEAL_CARD_SELECTOR,
) {
  if (!container || prefersReducedMotion()) {
    return null
  }

  return gsap.context(() => {
    const cards = gsap.utils.toArray<HTMLElement>(selector, container)

    gsap.set(cards, { opacity: 0, y: REVEAL_DISTANCE_PX })

    ScrollTrigger.batch(cards, {
      start: REVEAL_START,
      once: true,
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          duration: REVEAL_DURATION_S,
          ease: 'power3.out',
          stagger: REVEAL_STAGGER_S,
        }),
    })
  }, container)
}
